import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { changePassword } from "../api/account";
import "./Login.css";
import { logout, saveSession, startExpiryTimer, tokenExpired } from "../util/auth";

const ChangePassword: React.FC = () => {
  const navigate = useNavigate();
  const [currentPw, setCurrentPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (tokenExpired()) {
      logout(true);
      window.location.href = "/login";
      return;
    }

    startExpiryTimer();

    return () => {
      const win = window as Window & { __expiryTimer?: number };
      if (win.__expiryTimer) clearTimeout(win.__expiryTimer);
    };
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (newPw !== confirmPw) {
      setError("New passwords do not match.");
      return;
    }

    try {
      setSaving(true);
      const result = await changePassword(currentPw, newPw);
      if (result?.access_token) {
        saveSession(result.access_token);
      }
      startExpiryTimer();
      setSuccess("Password changed successfully.");
      setCurrentPw("");
      setNewPw("");
      setConfirmPw("");
      window.setTimeout(() => navigate("/"), 700);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to change password.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card login-container">
        <span className="auth-badge">Security</span>
        <h1 className="auth-title">Change password</h1>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="auth-error">{error}</div>}
          {success && <div className="ref-success">{success}</div>}

          <div className="field-group">
            <label htmlFor="currentPw">Current Password</label>
            <input
              id="currentPw"
              className="app-input"
              type="password"
              value={currentPw}
              onChange={(e) => setCurrentPw(e.target.value)}
              required
            />
          </div>

          <div className="field-group">
            <label htmlFor="newPw">New Password</label>
            <input
              id="newPw"
              className="app-input"
              type="password"
              value={newPw}
              onChange={(e) => setNewPw(e.target.value)}
              required
            />
          </div>

          <div className="field-group">
            <label htmlFor="confirmPw">Confirm New Password</label>
            <input
              id="confirmPw"
              className="app-input"
              type="password"
              value={confirmPw}
              onChange={(e) => setConfirmPw(e.target.value)}
              required
            />
          </div>

          <div className="toolbar auth-actions">
            <button
              type="button"
              className="app-button secondary"
              onClick={() => navigate("/")}
              disabled={saving}
            >
              Cancel
            </button>
            <button type="submit" className="app-button primary" disabled={saving}>
              {saving ? "Saving..." : "Save Password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
